import React, { HTMLAttributes } from 'react';

import { View } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import { ParagraphPartnersOverview as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphPartnersOverviewProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphPartnersOverview: React.FC<ParagraphPartnersOverviewProps> = ({ entity }) => {
  const paragraph = entity.toJS();
  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0]?.value;

  return (
    <div className="Paragraph ParagraphPartnersOverview">
      <Container>
        <div className="row">
          <div className="ParagraphPartnersOverview__content col-12 col-md-10 col-lg-8">
            {title && <h2>{title}</h2>}
            {body && (
              <div className="ParagraphPartnersOverview__body">
                <WysiwygField
                  className="text--large"
                  html={body}
                />
              </div>
            )}
          </div>
        </div>
        <View
          id="partners"
          display="overview"
        />
      </Container>
    </div>
  );
};

export default ParagraphPartnersOverview;
